import React from 'react'

export const Logo = (props) => 
	<svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Laag 1"
    viewBox="0 0 1500 210.78"
    className="logo-svg"
  >
    <path
      d="M419.19 47.91c-20.07 0-33.22 14.57-33.22 36.8 0 21 13.86 35.85 33.93 35.85 20.32 0 33.7-14.34 33.7-36.33 0-21.75-13.86-36.32-34.41-36.32z"
      className="cls-1"
      transform="translate(0 -.11)"
    ></path>
    <path
      d="M208.61 109.22L258.56 109.22 233.71 44.69 208.61 109.22z"
      className="cls-1"
    ></path>
    <path
      d="M738.67 109.22L788.62 109.22 763.77 44.69 738.67 109.22z"
      className="cls-1"
    ></path>
    <path
      d="M733.9 2.26l-74.32 163h56.64L727 138.72h73.6l10.75 26.53H868l-74.32-163zm4.77 107.07l25.1-64.53 24.85 64.53z"
      className="cls-2"
      transform="translate(0 -.11)"
    ></path>
    <path
      d="M938.93 2.15L881.82 2.15 881.82 165.13 1002.97 165.13 1002.97 124.27 938.93 124.27 938.93 2.15z"
      className="cls-2"
    ></path>
    <path
      d="M1079.89 99.65L1139.39 99.65 1139.39 65.24 1079.89 65.24 1079.89 36.57 1144.89 36.57 1144.89 2.15 1022.78 2.15 1022.78 165.13 1145.84 165.13 1145.84 130.72 1079.89 130.72 1079.89 99.65z"
      className="cls-2"
    ></path>
    <path
      d="M1274.74 85.8L1215.89 2.15 1167.13 2.15 1167.13 165.13 1215.89 165.13 1215.89 81.49 1274.74 165.13 1319.79 165.13 1319.79 2.15 1274.74 2.15 1274.74 85.8z"
      className="cls-2"
    ></path>
    <path
      d="M1341.08 2.15L1341.08 43.02 1391.98 43.02 1391.98 165.13 1449.1 165.13 1449.1 43.02 1500 43.02 1500 2.15 1341.08 2.15z"
      className="cls-2"
    ></path>
    <path
      d="M678.4 2.15L638.9 2.15 565.43 163.27 565.43 165.13 601.24 165.13 604.34 165.13 627.5 165.13 627.5 43.02 678.4 43.02 678.4 2.15z"
      className="cls-2"
    ></path>
    <path
      d="M158.91 2.15L0 2.15 0 43.02 50.9 43.02 50.9 165.13 108.01 165.13 108.01 43.02 158.91 43.02 158.91 2.15z"
      className="cls-3"
    ></path>
    <path
      d="M203.84 2.26l-74.32 163h56.63l10.76-26.53h73.6l10.75 26.53h56.64l-74.32-163zm4.77 107.07l25.1-64.53 24.85 64.53zM510.71 84.47c0-43.25-29.39-84.36-92-84.36-63.8 0-89.85 43.5-89.85 82.93 0 36.8 20.79 66.91 62.37 89.85 24.14 13.38 72.4 33.22 94.39 38l37.28-34.41C504 171 488 164.29 468.65 154.25c27.96-16.25 42.06-39.67 42.06-69.78zm-90.81 36.09c-20.07 0-33.93-14.82-33.93-35.85 0-22.23 13.15-36.8 33.22-36.8 20.55 0 34.41 14.57 34.41 36.32 0 21.99-13.38 36.33-33.7 36.33z"
      className="cls-3"
      transform="translate(0 -.11)"
    ></path>
    <path
      d="M565.43 143.98L630.1 2.15 604.34 2.15 601.24 2.15 514.53 2.15 514.53 43.02 565.43 43.02 565.43 143.98z"
      className="cls-3"
    ></path>
  </svg>


// WEBPACK FOOTER //
// ./src/images/Logo.js